module.exports = __webpack_public_path__ + "img/29.72d9067.jpg";